import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
	selector: "app-button",
	templateUrl: "./button.component.html",
	styleUrls: ["./button.component.scss"],
	standalone: false
})
export class ButtonComponent {
	@Input() severity:
		| "primary"
		| "warning"
		| "danger"
		| "success"
		| "link"
		| "secondary"
		| "light" = "primary";
	@Input() iconPosition: "left" | "right" = "left";
	@Input() icon = "";
	@Input() isLoading = false;
	@Input() disabled = false;
	@Input() badge = "";
	@Input() blockBtn = false;
	@Input() isRounded = false;
	@Input() type: "button" | "submit" = "button";
	@Input() isOutline = false;
	@Input() form = "";

	@Output()
	clickBtn: EventEmitter<void> = new EventEmitter<void>();

	protected hasIcon(): boolean {
		return !!this.icon;
	}

	protected hasBadge(): boolean {
		return !!this.badge;
	}
}
